import { useCallback, useEffect, useState } from "react";

const useTableYScroll = (diff: number) => {
  const [y, updateY] = useState(() => window.innerHeight - diff);
  const updateYWhenResize = useCallback(() => {
    updateY(window.innerHeight - diff);
  }, []);
  useEffect(() => {
    window.addEventListener("resize", updateYWhenResize);
    return () => window.removeEventListener("resize", updateYWhenResize);
  }, [diff]);
  return y;
};

export default useTableYScroll;
